import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sprout } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function AuthCallback() {
  const { completeGoogle } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      const res = await completeGoogle(sessionId);
      window.history.replaceState(null, "", window.location.pathname);
      navigate(res.ok ? "/" : "/login", { replace: true });
    })();
  }, [completeGoogle, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-background">
      <div className="h-12 w-12 rounded-2xl bg-emerald-700 flex items-center justify-center animate-pulse">
        <Sprout className="h-6 w-6 text-white" />
      </div>
      <p className="text-sm text-muted-foreground">Signing you in…</p>
    </div>
  );
}
